export default __webpack_public_path__ + "static/media/bubble-smile.6ef9cab4.png";